module.exports = __webpack_public_path__ + "static/media/home-back-1.892a59da.png";